import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';

import '../assets/styles/main.scss';
import PageHelmet from '../components/PageHelmet';
import Footer from '../components/Footer';

const propTypes = {
  children: PropTypes.func,
};

function TemplateWrapper({ children, locale, messages }) {
  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale="pl">
      <div>
        <PageHelmet />

        {children()}

        <Footer />
      </div>
    </IntlProvider>
  );
}

TemplateWrapper.propTypes = propTypes;

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js